module.exports = __webpack_public_path__ + "static/media/steve-cleveland.0d7eaa3e.jpg";